import { text } from "@/theme/colors";
import { Box, CircularProgress, styled } from "@mui/material";

const Overlay = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  pointerEvents: "auto",
}));

type LoadingOverlayProps = {
  open?: boolean;
};

export function LoadingOverlay({ open = true }: LoadingOverlayProps) {
  if (!open) return null;

  return (
    <Overlay>
      <CircularProgress sx={{ color: text.secondary }} />
    </Overlay>
  );
}
